import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import FillFlow from 'components/Flows/FillFlows/FillFlows';
import FillAnalysisDrawer from 'components/Analyses/FillAnalyses/Drawer/Drawer';

const FillFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <FillAnalysisDrawer />
      <FillFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FillFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);